/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ITooltip {
  /** Заголовок тултипа **/
  title: string;
  /** Описание тултипа **/
  description: string;
  /** Название блока, к которому относится тултип **/
  anchorBlock: EAnchorBlock;
}

export enum EAnchorBlock {
  /** Блок оценки **/
  'Estimation' = 'estimation',
  /** Блок трендов рынка **/
  'MarketTrends' = 'marketTrends',
  /** Блок истории объявлений **/
  'OffersHistory' = 'offersHistory',
  /** Блок информации о доме **/
  'AboutHome' = 'aboutHome',
}
